const mistakes = [
  {
    icon: "ri-calendar-close-line",
    title: "Waiting Too Long to Start",
    desc: "Bozeman travelers flying out of BZN often underestimate processing times. Even expedited options take days — don't wait until the week before your trip.",
  },
  {
    icon: "ri-image-line",
    title: "Non-Compliant Passport Photos",
    desc: "The most common rejection reason. Photos must meet strict State Department standards — background, dimensions, expression, and recency all matter.",
  },
  {
    icon: "ri-file-damage-line",
    title: "Missing or Incorrect Documentation",
    desc: "Submitting the wrong form, wrong ID copy type, or missing citizenship proof causes costly delays. Fast Passport Center reviews everything before submission.",
  },
  {
    icon: "ri-map-pin-time-line",
    title: "Assuming Denver Is the Only Option",
    desc: "Many Bozeman residents don't realize a registered courier service like Fast Passport Center can access agencies without a 400+ mile drive to Denver.",
  },
  {
    icon: "ri-pen-nib-line",
    title: "Errors on the Application Form",
    desc: "A single incorrect field — wrong middle name, transposed date, missing signature — can cause your application to be returned and restart the clock.",
  },
  {
    icon: "ri-mail-send-line",
    title: "Using Slow Mail Methods",
    desc: "Standard mail to a passport agency adds days each way. Always use overnight or 2-day tracked shipping — and Fast Passport Center handles this for you.",
  },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Pitfalls</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            6 Passport Mistakes Bozeman Travelers Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These avoidable errors cost travelers days or weeks. Fast Passport Center catches every one before submission.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0 mt-0.5">
                <i className={`${m.icon} text-red-500 text-base`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}